<template>
  <div class="d-flex align-center">
    <AppTooltip location="bottom">
      <template #activator="{ props }">
        <img
          :src="projectCategoryIcon"
          width="24px"
          max-width="24px"
          alt="Room type icon"
          v-bind="props"
        />
      </template>
      <span v-if="room.isDataroom">{{ $t('common.RoomTypeIcon.dataroom') }}</span>
      <span v-else>{{ $t('common.RoomTypeIcon.project') }}</span>
    </AppTooltip>
  </div>
</template>

<script>
import AppTooltip from './AppTooltip.vue'
import { getRoomIcon } from './utils/rooms'

export default {
  name: 'RoomTypeIcon',
  components: { AppTooltip },
  props: {
    room: {
      type: Object,
      required: true,
    },
  },
  computed: {
    projectCategoryIcon () {
      return getRoomIcon(this.room)
    },
  },
}
</script>
